// extracted by mini-css-extract-plugin
export var alertIcon = "_ri-0";